/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Posts_Titleplaceholder1Inputs */

const he_posts_titleplaceholder1 = /** @type {(inputs: Posts_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הזן כותרת פוסט`)
};

const en_posts_titleplaceholder1 = /** @type {(inputs: Posts_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter post title`)
};

/**
* | output |
* | --- |
* | "Enter post title" |
*
* @param {Posts_Titleplaceholder1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const posts_titleplaceholder1 = /** @type {((inputs?: Posts_Titleplaceholder1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Posts_Titleplaceholder1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_posts_titleplaceholder1(inputs)
	return en_posts_titleplaceholder1(inputs)
});
export { posts_titleplaceholder1 as "posts_titlePlaceholder" }